include ../../../../../../common/primary/icon/icon.mixin.pug

.fp-vertical-spacing--line(v-if='!giveaways.isLoading() && giveaways.value().length')
  .fp-card.-highlighted
    .fp-vertical-spacing
      .fp-vertical-spacing--line
        h2.fp-title {{ t('marketplace.giveawayParticipations.earnExclusive') }}
      .fp-vertical-spacing--line
        span.fp-text {{ t('marketplace.giveawayParticipations.operationInProgress') }}
      .fp-vertical-spacing--line(v-for='(giveaway, index) in giveaways.value()' :key='index')
        .fp-horizontal-spacing.-items-center
          .fp-horizontal-spacing--column
            FairplayerImageVue.fp-illustration.-sm(:url='giveaway.logoUrl' :resolution='ImageResolution.SM')
          .fp-horizontal-spacing--column.-expand
            .fp-vertical-spacing.-s-xs
              .fp-vertical-spacing--line
                span.fp-text.-text-sm {{ t(giveaway.textKey) }}
              .fp-vertical-spacing--line
                span.fp-text.-text-semi-bold.-color-shade-900(:data-test='`giveaway.${index}.sponsor-name`') {{ giveaway.sponsorName }}
          .fp-horizontal-spacing--column
            a.fp-link.-no-text-decoration(:href='giveaway.url' :data-test='`giveaway.${index}.link`')
              FairplayerButtonVue(:text='t("marketplace.giveawayParticipations.participate")' icon='arrow-square-in')
